$('[data-youtube-src]').on('click', function (event) {
	
	event.preventDefault();
	let autoplay = 1;

	if (typeof $(this).data('autoplay') !== 'undefined') {
		autoplay =  $(this).data('autoplay') === true ? 1 : 0;
	}

	const src = `https://www.youtube.com/embed/${$(this).data("youtube-src")}?autoplay=${autoplay}`;

	$('#videoModal').modal('show');
	$('#videoModal iframe').attr('src', src);
});

$('#videoModal').on('hidden.bs.modal', function () {
	$('#videoModal iframe').removeAttr('src');
})
